export const IRTSoFTemplate = {
    name: 'sof_irt',
    label: 'IRT SoF',
    subject: "Order ${reference}: Additional documents required",
    category: 'compulsory',
    body: "<p>Hi ${payer_first_name},</p>"
        + "<p>Our banking partner has requested the following document/details, to process your payment of <b>${paid_amount} ${origin_currency}</b>. Please send the following items via email.</p>"
        + "<ul>"
        + "<li><b>A proof of account for the recipient NZD account.</b>"
        + "<ul>"
        + "<li>Must show name and address of the recipient</li>"
        + "<li>Must have your bank letterhead (logo)</li>"
        + "<li>Your transaction records are not needed.</li>"
        +"</ul>"
        + "</li>"
        + "<li><b>A bank statement in English or proof of account from the bank you made the IRT payment.</b>"
        + "<ul>"
        + "<li>Receive a print from your Iranian bank.</li>"
        + "<li>If the IRT account doesn’t belong to <i>${payer_first_name}</i>, payer must write a letter and explain.</li>"
        +"</ul>"
        + "</li>"
        + "<li><b>Nature and Purpose for this payment</b>"
        + "<ul>"
        + "<li>On your order you put: <i>'${reason}'</i>.<br/>"
        + "Please confirm and explain if you have more details."
        + "<li>Examples of other accepted supporting documents include:"
        + "<ul>"
        + "<li>Agreement with your NZ immigration advisor.</li>"
        + "<li>University admission showing fees.</li>"
        + "<li>Letter of support/gift from parents. IMPORTANT: Please compose the letter in Farsi and sign and get it translated officially.</li>"
        +"</ul>"
        + "</ul>"
        + "</li>"
        + "<li><b>Proof for Source of Wealth (SoW) / Source of Funds (SoF)</b>"
        + "<ul>"
        + "<li>This means where your <i>${paid_amount} ${origin_currency}</i> originated from.</li>"
        + "<li>It can be your payslip if you receive a salary.</li>"
        + "<li>If your fund is from your savings, please also send a bank statement of your savings account. (or parent’s account)</li>"
        + "<li>If you have sold any assets, please provide proof.</li>"
        + "</ul>"
        + "</li>"
        + "</ul>"
        + "<p>Please do not hesitate to contact us if you need assistance preparing these documents/details.</p>"
        + "<p>Kind regards</p>"
}

